import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import side from "../../Assets/Image/admin/side.png";
import men1 from "../../Assets/Image/admin/user.png";
import Menu from "../../Base-Component/Menu/Menu";
import Popover from "../../Base-Component/Popover/Popover";
import Dialog from "../../Base-Component/Dialog/Dialog";
import axios from "axios";
import Cookies from "js-cookie";
import { Circles, ThreeDots } from "react-loader-spinner";
import logos from "../../Assets/Image/admin/logos.png";
import toast from "react-hot-toast";
import { ADMIN_LOGOUT_API, IMG_URL } from "../../Services/Api";
import { getNotification, getUnreadNotificationCount } from "../../Services/ApiServices";
import { Socket } from "../../Socket/Socket";
import moment from "moment";
import InfiniteScroll from "react-infinite-scroll-component";
import notification from "../../Assets/Image/admin/notification.png";

function TopMenu(props) {
  const location = useLocation();
  const navigate = useNavigate();
  const [isModalOpens, setModalOpens] = useState(false);
  const [isLogOut, setIsLogOut] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [profilePic, setProfilePic] = useState("");
  const [notificationData, setNotificationData] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [unreadNotificationCount, setUnreadNotificationCount] = useState(0);

  const Token = Cookies.get("e_learning_token");
  axios.defaults.headers.common["Authorization"] = "Bearer " + Token;

  const handleLogout = () => {
    setIsLoading(true);
    axios
      .post(ADMIN_LOGOUT_API)
      .then((res) => {
        if (res.status == 200) {
          Cookies.remove("e_learning_token");
          localStorage.clear();
          navigate("/login");
        }
        setIsLoading(false);
      })
      .catch((err) => {
        if (err.response.status == 401) {
          Cookies.remove("e_learning_token");
          navigate("/login");
        } else {
          toast.error(err.response.data.message);
        }
        setIsLoading(false);
      });
  };

  const adminData = JSON.parse(localStorage.getItem("e-learn-data"));
  const adminId = adminData?.userId;

  useEffect(() => {
    if (adminData) {
      setProfilePic(adminData?.profilePic || adminData?.profile_image || "");
    }
  }, []);

  useEffect(() => {
    if (!adminId) return;

    if (!Socket.connected) {
      Socket.connect();
    }

    const onConnect = () => {
      console.log("Connected:", Socket.id);

      Socket.emit("socket_register", {
        user_id: adminId,
      });
    };

    const onNotification = (data) => {
      setUnreadNotificationCount(data?.data ?? 0);
      console.log("Notification Count:", data?.data);
    };

    Socket.on("connect", onConnect);
    Socket.on("notification_count", onNotification);

    // ✅ call ONLY once manually
    Socket.emit("notification_count");

    return () => {
      Socket.off("connect", onConnect);
      Socket.off("notification_count", onNotification);
    };
  }, [adminId]);

  const handleOpenNotification = () => {
    setPage(1);
    fetchNotifications(1);
    setUnreadNotificationCount(0);

    // optional backend read event
    Socket.emit("notification_read");
  };


  const fetchNotifications = (pageNumber) => {
    getNotification({ page: pageNumber }).then((res) => {
      if (res.status == 1 || res.status == 200) {
        const newData = res.data.data.map((item) => ({
          image: item.Category?.category_image ? (IMG_URL + item.Category.category_image) : men1,
          text: item.message,
          time: moment(item.createdAt).fromNow(),
          title: item.title,
        }));

        if (pageNumber === 1) {
          setNotificationData(newData);
        } else {
          setNotificationData((prev) => [...prev, ...newData]);
        }

        if (newData.length < 10) {
          setHasMore(false);
        } else {
          setHasMore(true);
        }
      }
    }).catch((err) => {
      console.error(err);
      setHasMore(false);
    });
  };

  const handleFetchMore = () => {
    const nextPage = page + 1;
    setPage(nextPage);
    fetchNotifications(nextPage);
  };

  useEffect(() => {
    getUnreadNotificationCount().then((res) => {
      if (res.status == 1 || res.status == 200) {
        setUnreadNotificationCount(res.data.notificationCount);
        console.log("Unread Count:", res.data.notificationCount);
      }
    }).catch((err) => {
      console.error(err);
    });
  }, []);

  const handleNotificationClick = (items, close) => {
    if (typeof close === "function") close(); // Close popover first so it dismisses immediately
    navigate("/users");
  };

  // console.log("Unread Count:", unreadNotificationCount);


  return (
    <>
      <header className="top-0 z-99 flex w-full bg-white drop-shadow-1 dark:bg-boxdark dark:drop-shadow-none">
        <div className="flex flex-grow items-center justify-between lg:justify-between py-4 px-4 shadow-2 md:px-8">
          <div className="flex items-center justify-between gap-2 sm:gap-4">
            <button
              aria-controls="sidebar"
              onClick={(e) => {
                e.stopPropagation();
                props.setSidebarOpen(!props.sidebarOpen);
              }}
              className="z-99 block rounded-sm border border-stroke bg-white p-1.5 shadow-sm dark:border-strokedark dark:bg-boxdark 2xl:hidden xl:hidden lg:hidden"
            >
              <span className="relative block h-5.5 w-5.5 cursor-pointer">
                <span className="du-block absolute right-0 h-full w-full">
                  <span
                    className={`relative top-0 left-0 my-1 block h-0.5 w-0 rounded-sm bg-black delay-[0] duration-200 ease-in-out dark:bg-white ${!props.sidebarOpen && "!w-full delay-300"
                      }`}
                  ></span>
                  <span
                    className={`relative top-0 left-0 my-1 block h-0.5 w-0 rounded-sm bg-black delay-150 duration-200 ease-in-out dark:bg-white ${!props.sidebarOpen && "delay-400 !w-full"
                      }`}
                  ></span>
                  <span
                    className={`relative top-0 left-0 my-1 block h-0.5 w-0 rounded-sm bg-black delay-200 duration-200 ease-in-out dark:bg-white ${!props.sidebarOpen && "!w-full delay-500"
                      }`}
                  ></span>
                </span>
                <span className="absolute right-0 h-full w-full rotate-45">
                  <span
                    className={`absolute left-2.5 top-0 block h-full w-0.5 rounded-sm bg-black delay-300 duration-200 ease-in-out dark:bg-white ${!props.sidebarOpen && "!h-0 !delay-[0]"
                      }`}
                  ></span>
                  <span
                    className={`delay-400 absolute left-0 top-2.5 block h-0.5 w-full rounded-sm bg-black duration-200 ease-in-out dark:bg-white ${!props.sidebarOpen && "!h-0 !delay-200"
                      }`}
                  ></span>
                </span>
              </span>
            </button>
            <div className="sm:flex items-center fontNew hidden">
              <h4 className="xl:text-xl lg:text-lg md:text-base font-semibold capitalize">
                {" "}
                {location.pathname
                  .split("/")[1]
                  .split("-")
                  .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                  .join(" ")}
              </h4>
              {location.pathname.split("/")[2] ? (
                <img src={side} className="w-2 mx-3 opacity-25" alt="" />
              ) : (
                ""
              )}
              {location.pathname.split("/")[2] ? (
                <h4 className="text-gray-400 capitalize">
                  {" "}
                  {location.pathname
                    .split("/")[2]
                    .split("-")
                    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                    .join(" ")}
                </h4>
              ) : (
                ""
              )}
            </div>
          </div>

          <div className="flex items-center gap-3">
            <Popover className="relative">
              <Popover.Button
                className="outline-0"
                onClick={handleOpenNotification}
              >
                <div className="ms-6 relative">
                  <img src={notification} className="2xl:w-10 2xl:h-10 w-10 h-10 rounded-full object-cover" alt="" />
                  {unreadNotificationCount > 0 && (
                    <div className="absolute top-0 right-0 -mt-1 -mr-1 flex h-6 w-6 items-center justify-center rounded-full bg-primary text-[10px] font-bold bg-[#e29c29] text-white shadow-sm border-2 border-white dark:border-boxdark">
                      {unreadNotificationCount > 99 ? "99+" : unreadNotificationCount}
                    </div>
                  )}
                </div>
              </Popover.Button>
              <Popover.Panel id="notifyside" className="lg:w-[450px] w-[330px] h-[500px] overflow-x-hidden sm:-mr-0 -mr-10 sm:px-6 px-3 mt-7">
                {({ close }) => (
                  <div className="fontNew py-2">
                    <p className="text-xl sm:text-2xl text-black dark:text-white font-semibold px-2 pb-2 border-b border-gray-200 dark:border-gray-600">Notifications</p>
                    <div
                      id="notifyside-scroll"
                      className="cursor-pointer h-[400px] overflow-y-auto"
                      style={{
                        scrollbarWidth: "none",
                        msOverflowStyle: "none",
                      }}
                    >
                      {notificationData.length <= 0 ? (
                        <div className="flex justify-center items-center h-full">
                          <p className="text-gray-500">No data found</p>
                        </div>
                      ) : (
                        <InfiniteScroll
                          dataLength={notificationData.length}
                          next={handleFetchMore}
                          hasMore={hasMore}
                          loader={
                            <div className="flex justify-center py-4">
                              <ThreeDots
                                width={40}
                                height={10}
                                color="#e29c29"
                                visible={true}
                              />
                            </div>
                          }
                          scrollableTarget="notifyside-scroll"
                        >
                          {notificationData.map((items, index) => {
                            return (
                              <div onClick={() => handleNotificationClick(items, close)} key={index} className="flex justify-around items-center fontNew py-2">
                                <img src={items.image} className="w-10 h-10 rounded-full flex-shrink-0" alt="" />
                                <div className="ps-3 flex-grow">
                                  <p className="m-0 text-black text-sm sm:text-base dark:text-white font-medium">{items.text}</p>
                                  <p className="text-xs sm:text-sm text-gray-500">{items.time}</p>
                                </div>
                              </div>
                            );
                          })}
                        </InfiniteScroll>
                      )}
                    </div>
                  </div>
                )}
              </Popover.Panel>
            </Popover>
            <div>
              <Menu>
                <Menu.Button className="block">
                  <img
                    src={logos}
                    crossOrigin="anonymous"
                    className="w-10 h-10"
                    alt=""
                  />
                </Menu.Button>
                <Menu.Items className="w-56 mt-px bg-white mt-6 fontNew">
                  <Menu.Item
                    className="hover:bg-[#e29c29] hover:text-white text-[#303438] flex justify-between items-center py-3"
                    onClick={() => {
                      navigate("/change-password");
                    }}
                  >
                    <div className="flex items-center">
                      <p className="m-0 ms-3">Change Password</p>
                    </div>
                  </Menu.Item>
                  <Menu.Item
                    className="hover:bg-[#e29c29] hover:text-white text-[#303438] flex justify-between items-center py-3"
                    onClick={() => {
                      setIsLogOut(true);
                    }}
                  >
                    <div className="flex items-center">
                      <p className="m-0 ms-3">Log out</p>
                    </div>
                  </Menu.Item>
                </Menu.Items>
              </Menu>
            </div>
          </div>
        </div>
      </header >

      <Dialog open={isLogOut} onClose={() => setIsLogOut(false)} size="2xl">
        <Dialog.Panel>
          <Dialog.Description className="rounded-none border-2 border-white">
            <div className="flex justify-center text-center my-4 sm:px-16 px-4 fontNew">
              <div>
                <h4 className="text-xl font-semibold text-black mt-6">
                  Log Out?
                </h4>
                <p className="text-sm text-gray-500 my-3">
                  Are you certain you wish to proceed with <br /> logging out?
                </p>
                <div className="mt-13 flex items-center mb-5">
                  <button
                    className="bg-[#F4F5FA] h-[50px] sm:w-36 w-30 text-sm rounded-xl sm:mx-3 mx-2"
                    onClick={() => setIsLogOut(false)}
                  >
                    Close
                  </button>
                  <button
                    className="bg-[#e29c29] h-[50px] sm:w-36 w-30 text-sm rounded-xl sm:mx-3 mx-2 text-white"
                    onClick={handleLogout}
                  >
                    {isLoading ? (
                      <div className="flex justify-center">
                        <Circles
                          width={25}
                          height={25}
                          color="#fff"
                          ariaLabel="circles-loading"
                          wrapperStyle={{}}
                          visible={true}
                          wrapperClass=""
                        />
                      </div>
                    ) : (
                      "Yes, Log Out"
                    )}
                  </button>
                </div>
              </div>
            </div>
          </Dialog.Description>
        </Dialog.Panel>
      </Dialog>
    </>
  );
}

export default TopMenu;
